module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-4-c8942c29f7bd45e39ed7506b43cd5f1a.svg";